import React from 'react'
import {
  Box,
  IconButton,
  InputAdornment,
  Paper,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'
import TextField from '../common/TextField'
import { getAccent, hexToRgba } from './constants'

const PrivilegeSearch = ({
  value,
  onChange,
  translate,
  themecolors = {},
}) => {
  const accent = getAccent(themecolors)
  const bg = themecolors.backgroundColor || themecolors.white || '#fff'
  const text = themecolors.textColor || '#222'
  const inputBg = themecolors.inputFieldBg || themecolors.lightGrey || '#f5f5f5'

  return (
    <Paper
      elevation={0}
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 5,
        px: 1.5,
        py: 1.25,
        mb: 1.5,
        borderRadius: '12px',
        background: `linear-gradient(180deg, ${bg} 0%, ${inputBg} 100%)`,
        border: `1px solid ${hexToRgba(accent, 0.1)}`,
        boxShadow: `0 4px 16px ${hexToRgba(accent, 0.08)}`,
        backdropFilter: 'blur(8px)',
      }}
    >
      <TextField
        fullWidth
        margin="dense"
        variant="outlined"
        value={value || ''}
        onChange={onChange}
        placeholder={
          translate('searchPrivileges') || translate('search')
        }
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: hexToRgba(accent, 0.12),
                }}
              >
                <SearchIcon sx={{ fontSize: 16, color: accent }} />
              </Box>
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={() => onChange({ target: { value: '' } })}
                sx={{
                  color: themecolors.themeDarkColor || '#667085',
                  '&:hover': {
                    color: text,
                    backgroundColor: hexToRgba(accent, 0.08),
                  },
                }}
              >
                <CloseIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            backgroundColor: bg,
            transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
            '& fieldset': {
              borderColor: hexToRgba(accent, 0.12),
            },
            '&:hover fieldset': {
              borderColor: hexToRgba(accent, 0.35),
            },
            '&.Mui-focused fieldset': {
              borderColor: accent,
              borderWidth: '1px',
            },
            '&.Mui-focused': {
              boxShadow: `0 0 0 3px ${hexToRgba(accent, 0.12)}`,
            },
          },
          '& .MuiOutlinedInput-input': {
            fontSize: '13px',
            color: text,
            py: '10px',
          },
        }}
      />
    </Paper>
  )
}

export default PrivilegeSearch
